import { client, useQuery } from '@fhs/client';

import type { MenuQueryOpts } from './types';

export const useMenuPickerQuery = ({
  slug,
  menuQueryOpts: { restaurantId, serviceMode, region },
  selectedOfferId,
}: {
  slug: string;
  menuQueryOpts: MenuQueryOpts;
  selectedOfferId?: string;
}) =>
  useQuery({
    enabled: Boolean(slug && restaurantId && serviceMode),
    queryKey: ['menus', restaurantId, serviceMode, slug, selectedOfferId],
    queryFn: async () => {
      if (!(restaurantId && serviceMode && slug)) {
        return;
      }
      const { data: menuItem, errors } = await client.queries.getMenuPickerForRestaurant({
        slug,
        restaurantId,
        serviceMode,
        region,
        selectedOfferId,
      });

      if (errors?.length) {
        throw new Error(errors[0].message);
      }
      return menuItem;
    },
  });
